import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule, IconModule, IncrementModule, isEmpty } from '@hglobal/common';
import {
  ShopOrder, OrderProduct, ShopOrderPayload, PickupLocation, OrderUser,
} from '@pt/models';
import { MfeUrlSegments } from '@pt/mfe';
import { ImageLoaderDirective } from '@pt/directives';
import { CoinComponent } from '@pt/components';

import { DeliveryFormComponent } from './components/delivery-form/delivery-form.component';

@Component({
  selector: 'pt-shop-order',
  templateUrl: './shop-order.component.html',
  styleUrls: ['./shop-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    TranslateModule,
    RouterLink,
    IconModule,
    ButtonModule,
    ImageLoaderDirective,
    CoinComponent,
    IncrementModule,
    DeliveryFormComponent,
  ],
})
export class ShopOrderComponent {
  readonly #mfeUrlSegments = inject(MfeUrlSegments);

  order = input<ShopOrder>();
  user = input<OrderUser | undefined>(undefined);
  stocks = input<Record<string, number>>({});
  pickupLocations = input<PickupLocation[]>([]);
  cancelLink = input<string>('');
  cancelName = input<string>('');

  changeProductQuantity = output<OrderProduct>();
  removeProduct = output<OrderProduct>();
  removeAllProducts = output<void>();
  locationChanged = output<PickupLocation>();
  saveOrder = output<ShopOrderPayload>();

  readonly shopSegment = `/${this.#mfeUrlSegments.shop}`;
  readonly minQuantity = 1;

  changeQuantity(product: OrderProduct, quantity: number): void {
    const newProduct = { ...product, quantity };
    this.changeProductQuantity.emit(newProduct);
  }

  isInvalidQuantity(product: OrderProduct): boolean {
    const stockQuantity = this.stocks()[product.productOption.id];
    return !isEmpty(stockQuantity) && product.quantity > stockQuantity;
  }
}
